const errors = {
  "api.error.payment.promo-code.invalid": "Código promocional inválido",
  "api.error.payment.promo-code.inactive": "Este código promocional no está activo",
  "api.error.payment.promo-code.first-time-only": "Este código promocional solo puede ser usado una vez",
  "api.error.payment.promo-code.already-used": "Ya has usado este descuento, y no puede ser aplicado nuevamente",
};

export const api = {
  ...errors,
};
